<template>
  <v-card>
    <v-toolbar dark>
      <v-toolbar-title class="white--text">Locations</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Download report file -->
      <transition name="slide-x-reverse-transition">
        <v-text-field
          v-if="selected.length"
          readonly
          single-line
          v-model="selectedMonth"
          label="Download transaction file"
          prepend-icon="mdi-calendar-range"
          class="mr-2"
          @click="showPicker = true"
          :disabled="loading"
        ></v-text-field>
      </transition>

      <!-- Search -->
      <v-text-field
        single-line
        prepend-icon="mdi-magnify"
        label="search"
        v-model="search"
      ></v-text-field>

      <!-- Download link -->
      <a v-show="false" ref="downlink" href=""></a>
    </v-toolbar>

    <!-- List -->
    <v-data-table
      :headers="headers"
      :items="locations"
      :search="search"
      :pagination.sync="pagination"
      :loading="loading"
      v-model="selected"
      select-all
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td>{{ props.item.vending_machine_id.split('-')[0] }}</td>
          <td>{{ props.item.site_code || '-' }}</td>
          <td>
            <span>{{ props.item.name }}</span>
            <router-link
                :to="{ name: 'location', params: { id: props.item.id }}"
                target="_blank"
                class="icon-link"
                @click.native.stop=""
              >
              <v-icon size="18" class="ml-1">mdi-open-in-new</v-icon>
            </router-link>
          </td>
          <td>{{ props.item.address }}</td>
        </tr>
      </template>
    </v-data-table>

    <!-- Month Picker -->
    <v-dialog
      ref="monthPicker"
      v-model="showPicker"
      :return-value.sync="selectedMonth"
      single-line
      lazy
      full-width
      width="290px"
    >
      <v-date-picker v-model="selectedMonth" type="month" scrollable dark>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="showPicker = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.monthPicker.save(selectedMonth); downloadFile()">Download</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-card>
</template>

<script>
import locationService from '@/services/location'
import reportService from '@/services/report'

export default {
  data () {
    return {
      loading: false,
      locations: [],
      selected: [],
      headers: [
        { text: 'Serial', value: 'vending_machine_id', sortable: true },
        { text: 'Code', value: 'site_code' },
        { text: 'Name', value: 'name' },
        { text: 'Address', value: 'address' }
      ],
      pagination: { rowsPerPage: -1 },
      search: null,

      selectedMonth: null,
      showPicker: false
    }
  },

  methods: {
    async getList () {
      this.loading = true

      const { data } = await locationService.getAll()
      this.locations = data.data

      this.loading = false
    },

    async downloadFile () {
      this.loading = true
      const yearMonth = this.selectedMonth.split('-')
      const locationIds = this.selected.map(selection => selection.id)
      const { data } = await reportService.get(locationIds, yearMonth[0], yearMonth[1])

      this.$refs.downlink.href = window.URL.createObjectURL(new Blob([data]))
      this.$refs.downlink.setAttribute('download', `transaction-${Date.now()}.xlsx`);
      this.$refs.downlink.click();

      this.loading = false
    }
  },

  created () {
    this.getList()
  }
}
</script>

<style>

</style>
